import data from "../data/treasure-hunt.json";

export const LETTERS = ["A", "B", "C", "D"];
export const DIFFICULTIES = ["easy", "medium", "hard"];
export const POINTS = { easy: 10, medium: 20, hard: 30 };

const pad = (n) => String(n).padStart(2, "0");
export { pad };

export const SETS = data.treasure_hunt.sets.map((set) => {
  const questions = set.questions.map((q, i) => {
    const difficulty = q.difficulty;
    return {
      id: q.id,
      set: set.set_id,
      index: i + 1,
      difficulty,
      points: q.points ?? POINTS[difficulty],
      text: q.question,
      options: q.options.map((o) => o.text),
      answerIndex: q.options.findIndex((o) => o.id === q.answer),
    };
  });
  return {
    id: set.set_id,
    questions,
    total: questions.reduce((sum, q) => sum + q.points, 0),
  };
});

export const QUESTIONS = SETS.flatMap((s) => s.questions);

export function statusOf(q, picks) {
  const pick = picks[q.id];
  if (pick === undefined) return "unverified";
  return pick === q.answerIndex ? "correct" : "incorrect";
}

export function searchQuestions(term) {
  const needle = term.trim().toLowerCase();
  if (!needle) return [];
  const asSet = /^\d+$/.test(needle) ? Number(needle) : null;
  return QUESTIONS.filter((q) => {
    if (asSet !== null && q.set === asSet) return true;
    const hay = `${q.id} ${q.text} ${q.options.join(" ")} ${q.difficulty} set ${q.set} set ${pad(q.set)}`;
    return hay.toLowerCase().includes(needle);
  });
}

export const EMPTY_TEAM = { checks: {}, notes: {}, sets: {} };

// Team-wide view of one question: who checked it, who missed, what notes exist.
export function teamInfo(q, team) {
  const checks = Object.entries(team.checks[q.id] ?? {});
  const notes = team.notes[q.id] ?? [];
  const misses = checks.filter(([, c]) => c.pick !== q.answerIndex).length;
  const suggestions = notes.filter((n) => n.kind === "suggest").length;
  const checked = checks.length > 0;
  const flagged = misses > 0 || suggestions > 0;
  return {
    checked,
    flagged,
    hits: checked ? checks.length - misses : 0,
    misses,
    notes,
    // "correct" | "incorrect" | "unverified" so it shares symbols with personal status
    status: flagged ? "incorrect" : checked ? "correct" : "unverified",
  };
}

export function myPicks(team, reviewer) {
  const picks = {};
  for (const [qid, byReviewer] of Object.entries(team.checks)) {
    if (byReviewer[reviewer]) picks[qid] = byReviewer[reviewer].pick;
  }
  return picks;
}

export const initials = (name) =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
